import { motion } from 'framer-motion';

// Fine architectural grid + slowly moving halos. Used behind sections.
export default function AnimatedBackground({ intensity = 'normal' }) {
  const halos = intensity === 'strong';
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden>
      {/* fine grid */}
      <div className="absolute inset-0 grid-bg-fine opacity-70" />
      {/* darker vignette */}
      <div className="absolute inset-0" style={{ background: 'radial-gradient(circle at 50% 20%, rgba(255,255,255,0.04), transparent 60%)' }} />
      {/* halos */}
      <motion.div
        className="halo"
        style={{ width: 520, height: 520, background: '#8b8b8b', top: '-160px', left: '-140px' }}
        animate={{ x: [0, 80, 0], y: [0, 40, 0] }}
        transition={{ duration: 22, repeat: Infinity, ease: 'easeInOut' }}
      />
      {halos && (
        <motion.div
          className="halo"
          style={{ width: 640, height: 640, background: '#5b5b5b', bottom: '-240px', right: '-160px', opacity: 0.28 }}
          animate={{ x: [0, -60, 0], y: [0, -30, 0] }}
          transition={{ duration: 28, repeat: Infinity, ease: 'easeInOut' }}
        />
      )}
      {/* thin vertical guide lines */}
      <div className="absolute inset-y-0 left-[16.66%] w-px bg-white/[0.05]" />
      <div className="absolute inset-y-0 left-[50%] w-px bg-white/[0.05]" />
      <div className="absolute inset-y-0 left-[83.33%] w-px bg-white/[0.05]" />
    </div>
  );
}
